/**
 * UI 表示の基準日
 * ステート遷移の基準日（6/1, 9/1）はバックエンドの calculateState で管理
 */
export const STATE_TRANSITION_DATES = {
  /** 播種バー表示開始日（4月1日） */
  SEEDING_BAR_START: { month: 4, day: 1 },
  /**
   * 播種バー表示終了日（6月1日。この日は含まない）。
   * バックエンドの PEST_CONTROL_START と同日。
   * 6/1 以降は EMERGENCE 登録があれば PEST_CONTROL に強制遷移するため、
   * BEFORE_SEEDING のまま残っている圃場に播種バーを出す意味がない。
   */
  SEEDING_BAR_END: { month: 6, day: 1 },
} as const;

/** 基準日のキー型 */
export type TransitionDateKey = keyof typeof STATE_TRANSITION_DATES;

/**
 * 指定日が基準日以降かどうかを判定
 * 年は無視し、月日のみで比較
 *
 * @param date 判定対象の日付
 * @param criteria 基準日（月, 日）
 * @returns 基準日以降なら true
 */
export function isDateOnOrAfter(date: Date, criteria: { month: number; day: number }): boolean {
  const month = date.getMonth() + 1; // 0-indexed to 1-indexed
  const day = date.getDate();

  if (month > criteria.month) {
    return true;
  }
  if (month === criteria.month && day >= criteria.day) {
    return true;
  }
  return false;
}

/**
 * 指定日が播種バー・出芽予測バーの表示期間内（4/1 ≤ date < 6/1）かを判定。
 * 年は無視し、月日のみで判定する。
 *
 * @param date 判定対象の日付
 * @returns 表示期間内なら true
 */
export function isWithinSeedingBarPeriod(date: Date): boolean {
  return (
    isDateOnOrAfter(date, STATE_TRANSITION_DATES.SEEDING_BAR_START) &&
    !isDateOnOrAfter(date, STATE_TRANSITION_DATES.SEEDING_BAR_END)
  );
}
